"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoDetectSourceLanguagesOpenRangeOptionName = exports.ForceDictationPropertyName = exports.ServicePropertiesPropertyName = exports.CancellationErrorCodePropertyName = exports.OutputFormatPropertyName = exports.SpeechSynthesisAdapter = exports.AvatarSynthesisAdapter = void 0;
// Make sure not to export internal modules.
//
__exportStar(require("./CognitiveSubscriptionKeyAuthentication.js"), exports);
__exportStar(require("./CognitiveTokenAuthentication.js"), exports);
__exportStar(require("./IAuthentication.js"), exports);
__exportStar(require("./IConnectionFactory.js"), exports);
__exportStar(require("./ISynthesisConnectionFactory.js"), exports);
__exportStar(require("./RecognitionEvents.js"), exports);
__exportStar(require("./ServiceRecognizerBase.js"), exports);
__exportStar(require("./ConversationServiceRecognizer.js"), exports);
__exportStar(require("./RecognizerConfig.js"), exports);
__exportStar(require("./SpeechServiceInterfaces.js"), exports);
__exportStar(require("./WebsocketMessageFormatter.js"), exports);
__exportStar(require("./SpeechConnectionFactory.js"), exports);
__exportStar(require("./ConversationTranscriberConnectionFactory.js"), exports);
__exportStar(require("./TranscriberConnectionFactory.js"), exports);
__exportStar(require("./TranslationConnectionFactory.js"), exports);
__exportStar(require("./SpeechSynthesisConnectionFactory.js"), exports);
__exportStar(require("./EnumTranslation.js"), exports);
__exportStar(require("./ServiceMessages/Enums.js"), exports);
__exportStar(require("./ServiceMessages/TranslationSynthesisEnd.js"), exports);
__exportStar(require("./ServiceMessages/TranslationHypothesis.js"), exports);
__exportStar(require("./ServiceMessages/TranslationPhrase.js"), exports);
__exportStar(require("./TranslationServiceRecognizer.js"), exports);
__exportStar(require("./ServiceMessages/SpeechDetected.js"), exports);
__exportStar(require("./ServiceMessages/SpeechHypothesis.js"), exports);
__exportStar(require("./ServiceMessages/SpeechKeyword.js"), exports);
__exportStar(require("./SpeechServiceRecognizer.js"), exports);
__exportStar(require("./ConversationTranscriptionServiceRecognizer.js"), exports);
__exportStar(require("./TranscriptionServiceRecognizer.js"), exports);
__exportStar(require("./ServiceMessages/DetailedSpeechPhrase.js"), exports);
__exportStar(require("./ServiceMessages/SimpleSpeechPhrase.js"), exports);
__exportStar(require("./RequestSession.js"), exports);
__exportStar(require("./SpeechContext.js"), exports);
__exportStar(require("./DynamicGrammarBuilder.js"), exports);
__exportStar(require("./DialogServiceAdapter.js"), exports);
__exportStar(require("./AgentConfig.js"), exports);
__exportStar(require("./Transcription/Exports.js"), exports);
__exportStar(require("./ServiceMessages/SynthesisAudioMetadata.js"), exports);
__exportStar(require("./SynthesisTurn.js"), exports);
__exportStar(require("./SynthesisAdapterBase.js"), exports);
var AvatarSynthesisAdapter_js_1 = require("./AvatarSynthesisAdapter.js");
Object.defineProperty(exports, "AvatarSynthesisAdapter", { enumerable: true, get: function () { return AvatarSynthesisAdapter_js_1.AvatarSynthesisAdapter; } });
var SpeechSynthesisAdapter_js_1 = require("./SpeechSynthesisAdapter.js");
Object.defineProperty(exports, "SpeechSynthesisAdapter", { enumerable: true, get: function () { return SpeechSynthesisAdapter_js_1.SpeechSynthesisAdapter; } });
__exportStar(require("./SynthesisRestAdapter.js"), exports);
__exportStar(require("./SynthesizerConfig.js"), exports);
__exportStar(require("./SynthesisContext.js"), exports);
__exportStar(require("./SpeechServiceConfig.js"), exports);
exports.OutputFormatPropertyName = "OutputFormat";
exports.CancellationErrorCodePropertyName = "CancellationErrorCode";
exports.ServicePropertiesPropertyName = "ServiceProperties";
exports.ForceDictationPropertyName = "ForceDictation";
exports.AutoDetectSourceLanguagesOpenRangeOptionName = "UND";

//# sourceMappingURL=Exports.js.map
